module.exports = function getLabelFromRelationship(relationship) {
	if (!relationship) return "";
	if (!relationship.data) return "";
	let rels = Array.isArray(relationship.data) ? relationship.data : [relationship.data];
	let labels = rels.map((rel) =>
		rel.attributes.name ? rel.attributes.name : rel.attributes.title
	);
	return labels.length ? `${labels.join(", ")}` : "";
};
